export default __webpack_public_path__ + "static/media/Background_00229.6692983a.png";